import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface TutorInfoFieldsProps {
  tutorName: string;
  setTutorName: (value: string) => void;
  studentName: string;
  setStudentName: (value: string) => void;
}

export const TutorInfoFields = ({
  tutorName,
  setTutorName,
  studentName,
  setStudentName,
}: TutorInfoFieldsProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="tutorName">Nombre Completo del Padre, Madre o Tutor</Label>
        <Input
          id="tutorName"
          type="text"
          value={tutorName}
          onChange={(e) => setTutorName(e.target.value)}
          required
          placeholder="Ingresa tu nombre completo"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="studentName">Nombre del Estudiante</Label>
        <Input
          id="studentName"
          type="text"
          value={studentName}
          onChange={(e) => setStudentName(e.target.value)}
          required
          placeholder="Ingresa el nombre del estudiante"
        />
      </div>
    </>
  );
};